export default "__VITE_ASSET__DOzQil65__"